module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-test-task/1.png?183e337ea9793e8aa315f48f930255bc";